import type { Category } from '@club/types/Category'
import { toBoolean } from '@web/common/Utils'
import { translit } from '@web/common/translit'

export default {
  toClient (data: unknown): Category {
    const d = data as {
      id: number | string
      title: string
      show_in_filters?: unknown
      sort?: number | string
    }
    return {
      id: Number(d.id),
      title: String(d.title),
      slug: String(translit(d.title)),
      show_in_filters: Object.prototype.hasOwnProperty.call(d, 'show_in_filters') ? toBoolean(d.show_in_filters as string | number | boolean) : true,
      sort: Number(d.sort || 0)
    } as Category
  }
}
